module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.966f81eb.png";